
import { map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';

@Injectable()
export class EditorRouteGuard implements CanActivate {


    constructor(
        private router: Router,
        private currentUserStateService: CurrentUserStateService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserStateService.getPermissions().pipe(
            filter(x => x !== null),
            map(permissions => {
                if (!!permissions.find(x => x === userPermissionsEnum.wireEditorial)) {
                    return true;
                } else {
                    this.router.navigate(['Amplify', 'wires']);
                }
            }),
        );
    }
}
